<template>
  <div @click="scrollToSection('#map-and-feeds')" class="cta-button">
    <slot></slot>

    <div class="cta-button__stripes cta-button__stripes--left"></div>
    <div class="cta-button__stripes cta-button__stripes--right"></div>
  </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";

export default {
  name: "cta-button",

  methods: {
    scrollToSection(elementId) {
      VueScrollTo.scrollTo(elementId, 700, { easing: "ease" });
    }
  }
}
</script>



// WEBPACK FOOTER //
// CtaButton.vue?135f37bd